var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Error") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Quote-Form",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Approved---Quote---Desktop",
    transform: "translate(-916.000000, -1184.000000)",
    fill: "#D50422"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Form/Field/Labelled-Copy-4",
    transform: "translate(373.000000, 1141.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(540.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0738834,14.1137099 C15.3390086,14.3788329 15.3390086,14.8085449 15.0738834,15.073885 C14.8087582,15.339008 14.3788255,15.339008 14.1137003,15.073885 L12.0000814,12.9602837 L9.88624545,15.073885 C9.62112026,15.339008 9.19140466,15.339008 8.92627947,15.073885 C8.66093715,14.8085449 8.66093715,14.3788329 8.92627947,14.1137099 L11.0398983,12.0001086 L8.92627947,9.88629013 C8.66093715,9.62116714 8.66093715,9.19123796 8.92627947,8.92611497 C9.19140466,8.66099198 9.62112026,8.66099198 9.88624545,8.92611497 L12.0000814,11.0399334 L14.1137003,8.92611497 C14.3788255,8.66099198 14.8087582,8.66099198 15.0738834,8.92611497 C15.3390086,9.19123796 15.3390086,9.62116714 15.0738834,9.88629013 L12.9602645,12.0001086 L15.0738834,14.1137099 Z M18.3656926,5.63283708 C14.8479946,2.12000285 9.1478476,2.12264607 5.63367502,5.63922485 C2.11972278,9.15580363 2.12236684,14.8541371 5.64006483,18.3671915 C9.15511876,21.8776028 14.8506387,21.8776028 18.3656926,18.3671915 C21.8781025,14.8484101 21.8781025,9.15139827 18.3656926,5.63283708 L18.3656926,5.63283708 Z",
    id: "Cross-Circle/Solid"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.af4fb1a32c6dcb3d9680d10a2036a0cd.svg";
export { ForwardRef as ReactComponent };